import { RouterModule } from '@angular/router'
import { DigitizationMapComponent } from './digitization-map.component'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { UpdateBuildingModalComponent } from './update-building-modal/update-building-modal.component'
import { ReactiveFormsModule } from '@angular/forms'
import { SharedModule } from '@shared/shared.module'
import { MapCoordinatesFinderModule } from '@components/map-coordinates-finder/map-coordinates-finder.module'

@NgModule({
  declarations: [DigitizationMapComponent, UpdateBuildingModalComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    RouterModule,
    TranslateModule,
    ContentEditableModule,
    ReactiveFormsModule,
    SharedModule,
    MapCoordinatesFinderModule,
  ],
  exports: [DigitizationMapComponent],
})
export class DigitizationMapModule {}
